const CONFIG_SELECTOR = '[data-sy-product-delivery-config]';
const FORM_SELECTOR = 'form[data-type="add-to-cart-form"]';
const PROPERTY_PREFIX = '_sy_delivery_';

if (!window.__syProductDeliveryConfigInitialized) {
  window.__syProductDeliveryConfigInitialized = true;

  function addHiddenProperty(form, name, value) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = `properties[${name}]`;
    input.value = String(value);
    input.dataset.syDeliveryProperty = 'true';
    form.append(input);
  }

  function configureProduct(config) {
    const sectionId = config.dataset.sectionId;
    const component = Array.from(document.querySelectorAll('product-form-component'))
      .find((element) => element.dataset.sectionId === sectionId);
    const form = component?.querySelector(FORM_SELECTOR);
    if (!form) return false;

    const expected = [
      [`properties[${PROPERTY_PREFIX}min_days]`, config.dataset.minDays || 2],
      [`properties[${PROPERTY_PREFIX}max_days]`, config.dataset.maxDays || 7],
      [`properties[${PROPERTY_PREFIX}validation]`, '1'],
      [`properties[${PROPERTY_PREFIX}property_name]`, config.dataset.propertyName || '配送希望日'],
    ];
    const existing = Array.from(form.querySelectorAll(`input[data-sy-delivery-property="true"][name^="properties[${PROPERTY_PREFIX}"]`));
    const alreadyConfigured = existing.length === expected.length && expected.every(([name, value]) =>
      existing.some((input) => input.name === name && input.value === String(value)),
    );
    if (alreadyConfigured) return true;

    existing.forEach((input) => input.remove());

    expected.forEach(([name, value]) => {
      addHiddenProperty(form, name.replace(/^properties\[|\]$/g, ''), value);
    });
    return true;
  }

  function syncAll() {
    document.querySelectorAll(CONFIG_SELECTOR).forEach(configureProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll, { once: true });
  } else {
    syncAll();
  }

  const observer = new MutationObserver(syncAll);
  observer.observe(document.documentElement, { childList: true, subtree: true });
}
